import React, { useCallback, useEffect, useState } from 'react';

import { Box, makeStyles, Theme, Typography } from '@material-ui/core';

import { ListShipParams } from './homeAPI';
import { listShipsThunk, selectShipList } from './homeSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import FilterForm, {
  FilterFormData,
  FILTER_DEFAULT_VALUE,
} from './components/FilterForm';
import Legend from '../../common/components/Legend';
import List from './components/List';
import Page from '../../common/components/Page';

const useStyles = makeStyles((theme: Theme) => ({
  reportListTitle: {
    backgroundColor: '#ffffff',
    marginBottom: '1rem',
    width: 'fit-content',
  },
}));

interface Props {
  title: string;
}

const HomePage = ({ title }: Props) => {
  const classes = useStyles();

  useEffect(() => {
    document.title = title;
  }, [title]);

  const dispatch = useAppDispatch();

  const shipList = useAppSelector(selectShipList);

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [filterValue, setFilterValue] =
    useState<FilterFormData>(FILTER_DEFAULT_VALUE);
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [ship, setShip] = useState<string>('');

  const onChangeRowsPerPage = useCallback((rows: number) => {
    setCurrentPage(1);
    setRowsPerPage(rows);
  }, []);

  const onRequestList = useCallback(
    ({ first, offset, shipName, filters }: ListShipParams) => {
      dispatch(listShipsThunk({ first, offset, shipName, filters }));
    },
    [dispatch]
  );

  const onChangeShipName = useCallback(
    (name: string) => {
      setShip(name);
      onRequestList({
        first: rowsPerPage * currentPage,
        offset: (currentPage - 1) * rowsPerPage,
        shipName: name,
        filters: { ...filterValue },
      });
    },
    [currentPage, filterValue, onRequestList, rowsPerPage]
  );

  const handleOnSubmit = useCallback(
    (data: FilterFormData) => {
      setFilterValue({ ...data });

      onRequestList({
        first: rowsPerPage * currentPage,
        offset: (currentPage - 1) * rowsPerPage,
        shipName: ship,
        filters: { ...data },
      });
    },
    [currentPage, onRequestList, rowsPerPage, ship]
  );

  useEffect(() => {
    onRequestList({
      first: rowsPerPage * currentPage,
      offset: (currentPage - 1) * rowsPerPage,
      filters: { ...filterValue },
    });
  }, [currentPage, filterValue, onRequestList, rowsPerPage]);

  return (
    <Page bgcolor="#f5f5f5" p={2}>
      <Box
        bgcolor="#ffffff"
        border="1px solid #ececec"
        borderRadius="4px"
        mt={2}
        p={2}
      >
        <Legend />
        <Box mt={2} py={2}>
          <FilterForm onSubmit={handleOnSubmit} />
        </Box>
      </Box>
      <Box
        bgcolor="#ffffff"
        border="1px solid #ececec"
        borderRadius="4px"
        mt={5}
        p={2}
      >
        <Typography
          className={classes.reportListTitle}
          color="primary"
          variant="h6"
        >
          Programação de Navios
        </Typography>
        <List
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          shipList={shipList}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onChangeShipName={onChangeShipName}
          onSetCurrentPage={setCurrentPage}
        />
      </Box>
    </Page>
  );
};

export default HomePage;
